/* eslint-disable no-unused-vars */
import { useId } from 'react';
import {
  ModalBase,
  ModalHeader,
  ModalFooter,
  ChooseBase,
  Each,
  CheckboxInner,
  ParagraphWithTooltip,
} from 'components';
import * as S from './CampaignReportChangeCols.styled';
import { campaignReportsAPI } from 'services/campaignReports.service';
import { useParams } from 'react-router-dom';
import { ArrowDown, ArrowRightForSelectedGroup, CheckTreeDividedColumns } from 'assets/icons';
import { useFacade } from './useFacade';
import { RightSide } from './rightSide/RightSide';
export const CampaignReportChangeCols = ({ isOpen$, dateFrom$, dateTo$ }) => {
  const {
    searchValue$,
    toggleGroup,
    isActiveGroup,
    isAllColsSelected$,
    groupCheckBoxClick,
    handleColOrEventSelector,
    isAllEventsSelected$,
    leftSideColumnsArray$,
    leftSideEventsArray$,
    rightSideSelectedCols$,
    rightSideSelectedEvents$,
    allColsArr$,
    idToNameObject$,
    handleSave,
  } = useFacade({
    dateFrom$,
    dateTo$,
  });

  const dataCheckBoxId = useId();
  const eventCheckBoxId = useId();

  return (
    <ModalBase>
      <ModalHeader
        title='Table Columns'
        close={() => {
          isOpen$.value = false;
        }}
      />
      <div style={{ display: 'flex', width: 601 }}>
        <S.Box>
          <ChooseBase.Divided
            title='Search'
            searchValue={searchValue$.value}
            searchOnChange={(e) => (searchValue$.value = e.target.value)}
            handleClearSearchValue={() => (searchValue$.value = '')}
          >
            <S.RowAndContent>
              <S.Row>
                <S.ArrowIconWrapper onClick={() => toggleGroup('Data')}>
                  {isActiveGroup('Data') ? (
                    <ArrowDown style={isActiveGroup('Data') && { fill: '#3B89F6' }} />
                  ) : (
                    <ArrowRightForSelectedGroup />
                  )}
                </S.ArrowIconWrapper>
                <CheckboxInner
                  readOnly
                  isChecked={isAllColsSelected$.value}
                  id={dataCheckBoxId}
                  name='Data'
                  onChange={() => groupCheckBoxClick('Data')}
                  isOpenGroup
                  label='Data'
                />
              </S.Row>
              {isActiveGroup('Data') && (
                <Each
                  of={leftSideColumnsArray$.value}
                  render={(item, index) => {
                    return (
                      <S.Container withShadow={!index}>
                        <CheckTreeDividedColumns />
                        <CheckboxInner
                          id={item.colName}
                          isChecked={item.isSelected}
                          name={item.label}
                          style={{ marginRight: '16px' }}
                          onChange={() => {
                            handleColOrEventSelector(item.colName, 'colName', 'column');
                          }}
                        />
                        <div style={{ width: '53%' }}>
                          <ParagraphWithTooltip
                            text={item.label}
                            isHighlight
                            search={searchValue$.value}
                          />
                        </div>
                      </S.Container>
                    );
                  }}
                />
              )}
            </S.RowAndContent>
            {leftSideEventsArray$.value?.length > 0 && (
              <S.RowAndContent>
                <S.Row>
                  <S.ArrowIconWrapper onClick={() => toggleGroup('Events')}>
                    {isActiveGroup('Events') ? (
                      <ArrowDown style={isActiveGroup('Events') && { fill: '#3B89F6' }} />
                    ) : (
                      <ArrowRightForSelectedGroup />
                    )}
                  </S.ArrowIconWrapper>
                  <CheckboxInner
                    isChecked={isAllEventsSelected$.value}
                    id={eventCheckBoxId}
                    name='Events'
                    onChange={() => groupCheckBoxClick('Events')}
                    isOpenGroup
                    label='Events'
                  />
                </S.Row>
                {isActiveGroup('Events') && (
                  <Each
                    of={leftSideEventsArray$.value}
                    render={(item, index) => {
                      return (
                        <S.Container withShadow={!index}>
                          <CheckTreeDividedColumns />
                          <CheckboxInner
                            id={item.eventId}
                            isChecked={item.isSelected}
                            name={`${item.eventName}`}
                            style={{ marginRight: '16px' }}
                            onChange={() => {
                              handleColOrEventSelector(item.eventId, 'eventId', 'event');
                            }}
                          />
                          <div style={{ width: '53%' }}>
                            <ParagraphWithTooltip
                              text={`${item.eventName}`}
                              isHighlight
                              search={searchValue$.value}
                            />
                          </div>
                        </S.Container>
                      );
                    }}
                  />
                )}
              </S.RowAndContent>
            )}
          </ChooseBase.Divided>
        </S.Box>
        <RightSide
          rightSideSelectedCols$={rightSideSelectedCols$}
          rightSideSelectedEvents$={rightSideSelectedEvents$}
          allColsArr$={allColsArr$}
          idToNameObject$={idToNameObject$}
        />
      </div>
      <ModalFooter
        saveButtonText='Save Columns'
        saveButtonOnClick={() => {
          handleSave(isOpen$);
          //isOpen$.value = false;
        }}
        close={() => {
          isOpen$.value = false;
        }}
        saveButtonDisabled={false}
      />
    </ModalBase>
  );
};
